import { render } from "./widgetConfig.vue?vue&type=template&id=6d4f7eac&scoped=true"
import script from "./widgetConfig.vue?vue&type=script&lang=js"
export * from "./widgetConfig.vue?vue&type=script&lang=js"

import "./widgetConfig.vue?vue&type=style&index=0&id=6d4f7eac&lang=less&scoped=true"

import exportComponent from "/data/app_data/product_data/deploy-center-mars/s3-deploy/damocstp/panel-cspt/v1.4.2-20260320-150211/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4f7eac"]])

export default __exports__